import { styled } from "@mui/material";

export const Content = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  // height: "calc(100vh - 206px)",
  justifyContent: "space-between",
  "& iframe": {
    border: "none",
    width: "100%",
  },
}));
